import { render, staticRenderFns } from "./MobileIndex.vue?vue&type=template&id=2ba3b952&"
import script from "./MobileIndex.vue?vue&type=script&lang=js&"
export * from "./MobileIndex.vue?vue&type=script&lang=js&"
import style0 from "./MobileIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports